import { CHURCH } from "../../lib/data";
import { resolveImg } from "../../lib/api";

export const MemberCard = ({ card }) => {
  if (!card) return null;
  const since = card.member_since ? new Date(card.member_since).toLocaleDateString("en-US", { month: "short", year: "numeric" }) : null;
  return (
    <div data-testid="membership-card" className="relative overflow-hidden rounded-2xl bg-[#0A0A0A] text-white p-6 sm:p-7 max-w-xl">
      <div className="absolute top-0 left-0 right-0 h-1.5 bg-[#E63946]" />
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src={CHURCH.logo} alt="" className="w-11 h-11 object-contain" />
          <div>
            <p className="font-display font-extrabold tracking-tight leading-tight">ONE LOVE MINISTRIES</p>
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#E63946]">Digital Membership Card</p>
          </div>
        </div>
        {card.photo ? <img src={resolveImg(card.photo)} alt="" className="w-12 h-12 rounded-full object-cover border-2 border-white/20" /> : null}
      </div>
      <div className="mt-6 flex items-end justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <p className="font-display font-bold text-2xl leading-tight truncate">{card.preferred_name || card.name}</p>
          <p className="text-sm text-white/50 mt-1">Member ID <span className="font-mono text-white/80">{card.member_id}</span></p>
          <span className="inline-block mt-2 text-xs px-3 py-1.5 rounded-full bg-[#E63946]/15 text-[#E63946] font-medium" data-testid="membership-status-badge">{card.membership_status}</span>
          {since && <p className="text-xs text-white/40 mt-2">Member since {since}</p>}
          <p className="text-xs text-white/35 mt-3">{CHURCH.address || "Little Rock, AR"} · {CHURCH.phone || "501-414-2963"}</p>
        </div>
        <div className="bg-white rounded-xl p-2 shrink-0">
          <img src={`${process.env.REACT_APP_BACKEND_URL}/api/members/card-qr/${card.card_code}.png`} alt="Membership QR"
            className="w-32 h-32 sm:w-36 sm:h-36" data-testid="membership-qr" />
        </div>
      </div>
      <p className="text-[10px] text-white/30 mt-4">Present this QR code to church staff for check-in. Scanning never reveals your private information.</p>
    </div>
  );
};
